import React from "react";
import styles from "./Newsletters.module.css";

const statusMap = {
  draft: styles.statusDraft,
  approved: styles.statusApproved,
  sent: styles.statusSent,
  failed: styles.statusFailed,
};

function NewsletterStatusBadge({ status }) {
  const normalized = String(status || "draft").toLowerCase();
  return (
    <span className={`${styles.statusBadge} ${statusMap[normalized] || styles.statusDraft}`}>
      {normalized}
    </span>
  );
}

export default NewsletterStatusBadge;
